import { materialsConstants } from '../constants';
import {List} from "immutable";

export function materials(state = {}, action) {
  switch (action.type) {
    case materialsConstants.GETMATERIALS_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        data: new List()
      });
    case materialsConstants.GETMATERIALS_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        data: action.data.data
      });
    case materialsConstants.GETMATERIALS_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        error: action.error
      });
    default:
      return state
  }
}
